import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setStatusMsg('感谢订阅！');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9pn291n2trhb35gvi9g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const code = parsed?.code;
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && code === 'OK') {
        setStatus('success');
        setStatusMsg('感谢订阅！每周为你精选最浪漫的旅行灵感。');
        setEmail('');
      } else {
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setStatusMsg('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setStatusMsg(serverMsg || '提交失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请稍后再试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50 dark:text-foreground-950 mb-3">
          订阅爱情岛周刊
        </h2>
        <p className="text-background-50/70 dark:text-foreground-950/70 text-sm md:text-base mb-8">
          每周一封邮件，为你精选最浪漫的旅行灵感、最新攻略和独家优惠。已有超过20,000对情侣订阅。
        </p>

        <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            readOnly
            aria-hidden="true"
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 w-full px-5 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white placeholder:text-white/50 text-sm outline-none focus:border-white/60 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-7 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-background-50' : 'text-background-50/80'}`}>
            {statusMsg}
          </p>
        )}
      </div>
    </section>
  );
}